import { Directive, Input, ElementRef, SimpleChanges, OnChanges } from '@angular/core';

@Directive({ selector: '[myFocus]' })
export class FocusDirective implements OnChanges {
	@Input('myFocus') isFocused: boolean;

	constructor(private hostElement: ElementRef) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.isFocused.currentValue === true) {
			setTimeout(() => this.hostElement.nativeElement.focus(), 350);
		}
	}
}
